import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EN from "./dictionary/en.json"
import AE from "./dictionary/ae.json"

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: EN,
      },
      ae: {
        translation: AE,
      },
      // Add more languages as needed
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if translation missing
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;